import React from 'react';
import { observer } from 'mobx-react';

import { ComponentBase, InjectedStyledComponent } from '../../../../../shared/index.js';

import { IDropdownHeaderConfiguration, IDropdownHeaderProps, IDropdownHeaderState } from './models/index.js';
import {
	DROPDOWN_HEADER_CATEGORY_KEY,
	DROPDOWN_HEADER_COMPONENT_KEY,
	DROPDOWN_HEADER_PARENT_COMPONENT_KEY,
} from './DropdownHeader.meta.js';

export class DropdownHeader extends ComponentBase<
	IDropdownHeaderProps,
	IDropdownHeaderState,
	IDropdownHeaderConfiguration
> {
	categoryKey = DROPDOWN_HEADER_CATEGORY_KEY;
	componentKey = DROPDOWN_HEADER_COMPONENT_KEY;

	headerRef: any;

	get parentComponentKey(): string | undefined {
		return DROPDOWN_HEADER_PARENT_COMPONENT_KEY;
	}

	constructor(props: IDropdownHeaderProps) {
		super(props);
		this.headerRef = React.createRef();
	}

	componentDidMount() {
		this.setFocus();
	}

	componentDidUpdate() {
		this.setFocus();
	}

	setFocus() {
		const { focus } = this.props;
		if (focus && this.headerRef) {
			this.headerRef.current.focus();
		}
	}

	render() {
		const {
			className,
			onClick,
			onKeyDown,
			isOpen,
			id,
			labelId,
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			selectedItemId,
			children,
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			focus,
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			configuration,
			...props
		} = this.props;

		return (
			<div
				className={className}
				id={id}
				aria-haspopup={'listbox'}
				aria-expanded={isOpen}
				onClick={onClick}
				onKeyDown={onKeyDown}
				tabIndex={0}
				role={'combobox'}
				ref={this.headerRef}
				aria-labelledby={labelId}
				{...props}
			>
				{children}
			</div>
		);
	}
}

export default InjectedStyledComponent(
	observer(DropdownHeader),
	DROPDOWN_HEADER_CATEGORY_KEY,
	DROPDOWN_HEADER_PARENT_COMPONENT_KEY,
	[DROPDOWN_HEADER_COMPONENT_KEY],
);
